module.exports = __webpack_public_path__ + "img/category-casino.c45ecfe7.png";